import { render, staticRenderFns } from "./Inaplicabilidade.vue?vue&type=template&id=974d34ac&scoped=true&"
import script from "./Inaplicabilidade.vue?vue&type=script&lang=js&"
export * from "./Inaplicabilidade.vue?vue&type=script&lang=js&"
import style0 from "./Inaplicabilidade.vue?vue&type=style&index=0&id=974d34ac&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974d34ac",
  null
  
)

export default component.exports